import H5Pay from '@hb/h5-pay';
import * as hbridge from '@hb/mbridge';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { getSystemCode } from '@/utils/systemCode';
import { getTokenAndLocation } from '@/utils';

const appEnv = process.env.VUE_APP_ENV || 'fat';

interface PayOrderInfo {
  businessType: string
  businessScene: string
  /** 支付金额 */
  payMoney: string;
  /** 支付编号 */
  payOrderId: string;
  /** 订单编号 */
  orderId: string;
}

const pay = async (info: {
  payOrderInfo: PayOrderInfo | PayOrderInfo[]
}): Promise<unknown> => {
  const { payOrderInfo } = info;
  const multiOrders = Array.isArray(payOrderInfo);
  const resolvedOrders = multiOrders ? payOrderInfo : [payOrderInfo];

  const { adCode, cityCode } = await getTokenAndLocation();
  // eslint-disable-next-line no-console
  console.log('开始支付了~~~');
  const h5Pay = new H5Pay({
    env: appEnv,
    systemCode: String(getSystemCode()),
    token: window.$$user.token || '',
    ubt: UBT,
    hbridge,
  });
  const payList = resolvedOrders.map(({
    payOrderId,
    payMoney,
    businessType,
    orderId,
  }) => ({
    guid: payOrderId,
    amount: payMoney,
    businessType,
    orderId,
  }));

  const [firstOrder] = resolvedOrders;

  const result = await h5Pay.pay({
    payParams: {
      businessType: firstOrder.businessType,
      businessScene: firstOrder.businessScene,
      payMoney: firstOrder.payMoney,
      adCode,
      cityCode,
      payList,
      sourceType: 9,
    },
    /**
     * 哈啰出行app，哈啰出行支付宝小程序不需token
     * 其他环境则需要token，不传token，则走不登陆支付方式
     */
    token: window.$$user.token,
    /**
     * 支付成功之后的跳转页面
     */
    successPageUrl: '',
    /**
     * 支付失败之后的跳转页面
     */
    failPageUrl: '',
    isNeedCancelCall: true,
    returnUrl: '',
  });
  return result;
};

export default pay;
